import {
    UpdateAttendanceDepartment
} from '../../../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi';
import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import ShiftTimePicker from '../ShiftTimePicker';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import {
    errorMsg,
    userDataTransformSupervisor,
    userListToLabelEmailPhoneValue
} from '../../../../../../../Apis/functions';
import HandleChange from '../../../../../../../Helpers/HandleChange';
import {PersonChipBlack} from "../../../../../../../components/buttons/IconButtons";
import {DeleteItemsApi} from "../../../../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../../../../Apis/Tables";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param show - Boolean to determine if the schedule update modal should be shown
 * @param onHide - Function to hide the modal when triggered
 * @param setModified - Function to set the updated status flag after schedule update
 * @param dataUpdate - The data to be used for updating the schedule
 */
const UpdateSchedule = ({ show, onHide, setModified, item, setItem }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedList, setSelectedList] = useState([]);
    const [emptyFields, setEmptyFields] = useState(false);
    const { handleChange: baseHandleChange } = HandleChange({ model: item, setModel: setItem });
    const [isValidRange, setIsValidRange] = useState(true);

    /**
     * Syncs supervisors from the item into the selectedList state.
     * Transforms raw supervisor data into UI-friendly label/value structure.
     */
    useEffect(() => {
        setSelectedList(item?.supervisors?.length > 0 ?
            userListToLabelEmailPhoneValue(userDataTransformSupervisor(item?.supervisors), 'userId', true, PersonChipBlack)
            : []);
    }, [item]);

    /**
     * Handles update of the schedule.
     * - Validates required fields and shift range.
     * - Removes unselected supervisors from backend if needed.
     * - Updates department schedule via API.
     * - Shows success/error feedback and updates parent state.
     */
    const handleUpdate = async() => {
        if (!item.isValid() || !isValidRange) {
            setEmptyFields(true);
            return;
        }
        const selectedIds = selectedList.map(s => s.userId);
        const filterIds = item?.supervisors?.filter(e => !selectedIds.includes(e.supervisorId));
        const deleteIds = filterIds.map(e => e.id);

        if(deleteIds.length > 0){
            const response = await dispatch(DeleteItemsApi({ tableName: TABLES.DEPARTMENT_SUPERVISOR, body: deleteIds, showToast:false }));
            if(!response?.payload?.data?.success){
                errorMsg(response?.payload?.data?.code);
                return;
            }
        }

        const { payload: {data :{ success, code }}}  = await dispatch(UpdateAttendanceDepartment(item.toAddEdit(selectedList)));

        if(success){
            toast.success(t('has_been_updated_successfully'));
            setModified(true);
            onHide();
        }else errorMsg(code);
    };

    /**
     * Handles input changes from form fields.
     * Normalizes values before updating the model state.
     */
    const handleChange = (e) => {
        const { name, value } = e.target;

        baseHandleChange({
            target: {
                name,
                value: item.normalizeValue(name, value),
            },
        });
    };

    /**
     * Validates shift time range whenever related fields change.
     * Ensures that start/end shift rules are respected.
     */
    useEffect(() => {
        setIsValidRange(item?.validateShifts());
    }, [
        item?.startShiftAt,
        item?.endShiftAt,
        item?.extensionDays
    ]);

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={handleUpdate}
            title='update'
            size='lg'
            cancelButton={true}
            confirmButton={true}
            classNameBody="pt-2"
        >
            <div className='row px-0'>
                <ShiftTimePicker
                    showNoSelectionOption={false}
                    item={item}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    displayNone={!item?.departmentId}
                    isValidRange={isValidRange}
                />
            </div>
        </CustomModal>
    );
};

export default UpdateSchedule;
